import type { FC } from 'react';
import styles from './InnerPageSection.module.css';

export const InnerPageSection: FC = ({ children }) => {
  return <section className={styles.container}>{children}</section>
}